import { Component, EventEmitter, Inject, Input, OnInit, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { SharedService } from "@shared/services/shared.service";

import { AdminService } from "app/services/admin/admin.service";
import { ComplaintService } from "app/services/complaint/complaint.service";


@Component({
  selector: 'business-gotoComplaint',
  styleUrls: ['./gotoComplaint.component.scss'],
  templateUrl: './gotoComplaint.component.html'
})

export class GotoComplaintComponent implements OnInit {

  // @Output() closeEvent = new EventEmitter<string>();

  constructor(
    private complaintService: ComplaintService,
    private sharedService: SharedService,
    private dialogRef: MatDialogRef<GotoComplaintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any  ) {

  }

  ngOnInit(): void {
  }


  close(): void {
    this.dialogRef.close();
  }
  
}